import styled, { css } from 'styled-components';

export const StyledButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ $gap }) => ($gap ? $gap : '8px')};
  padding: 11px 22px;
  border: 0;
  border-radius: 36px;
  font-size: 15px;
  line-height: 1.2;
  font-weight: 500;
  width: 100%;
  max-width: ${({ $width }) => $width && $width};
  white-space: nowrap;
  /* Sample .btn-person — people are orange */
  background: var(--primary-gradient);
  color: var(--primary-foreground);
  box-shadow: 0 0 15px rgba(10, 9, 8, 0.08);
  transition:
    transform 0.2s var(--ease),
    box-shadow 0.2s,
    background 0.2s,
    opacity 0.2s;
  overflow: hidden;

  &:hover:not(:disabled) {
    box-shadow: 0 0 0 4px var(--o-halo);
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  ${({ $loader, disabled }) =>
    $loader ||
    (disabled &&
      css`
        cursor: not-allowed;
        opacity: 0.55;
      `)}

  ${({ $lg }) =>
    $lg &&
    css`
      padding: 14px 28px;
      font-size: 16px;
      line-height: 1.2;
      font-weight: 600;
      width: ${({ $width }) => ($width ? $width : '283px')};
    `}

  /* Background-Variants-Start */
  ${({ $variant }) =>
    $variant === 'white' &&
    css`
      background: var(--card);
      color: var(--fg);
      box-shadow: 0 0 15px rgba(10, 9, 8, 0.14);
      .loader {
        border-top: 3px solid var(--ink) !important;
      }
    `}

  ${({ $variant }) =>
    $variant === 'primary' &&
    css`
      background: var(--primary-gradient);
      color: var(--primary-foreground);
    `}

  ${({ $variant }) =>
    $variant === 'light' &&
    css`
      background: #f1ece5;
      color: var(--ink);
      box-shadow: none;
    `}

  ${({ $variant }) =>
    $variant === 'secondary' &&
    css`
      background: #f1ece5;
      color: var(--ink);
      box-shadow: none;
    `}

  ${({ $variant }) =>
    $variant === 'secondary-outline' &&
    css`
      background: var(--card);
      color: var(--fg);
      border: 1px solid var(--line-2);
      box-shadow: none;
    `}

  ${({ $variant }) =>
    $variant === 'cross' &&
    css`
      background: transparent;
      color: var(--fg);
      border: none;
      box-shadow: none;
      padding: 0;
      border-radius: 0;
    `}

  ${({ $variant }) =>
    $variant === 'outline' &&
    css`
      background: var(--card);
      color: var(--fg);
      border: 1px solid var(--line-2);
      box-shadow: none;

      .loader {
        border-top: 3px solid var(--primary) !important;
      }
    `}

  ${({ $variant }) =>
    $variant === 'danger' &&
    css`
      background: var(--danger);
      color: #fff;
      box-shadow: none;
    `}

  /* Sample .btn-system — systems are black */
  ${({ $variant }) =>
    $variant === 'dark' &&
    css`
      background: var(--ink);
      color: #fff;
      box-shadow: none;

      &:hover:not(:disabled) {
        background: #2c2825;
        box-shadow: none;
      }
    `}
  /*****************Background Variants End*********************/

  /*****************Border Variants Start*********************/

  ${({ $outline }) =>
    $outline &&
    css`
      border: 1px solid var(--line);
      background: transparent;
      color: var(--text-color);
      box-shadow: none;
    `}
  /*****************Border Variants End*********************/

  .loader {
    width: 17px;
    height: 17px;
    border-radius: 50%;
    display: inline-block;
    border-top: 3px solid var(--ink);
    border-right: 3px solid transparent;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    ${({ $lg }) =>
      $lg &&
      css`
        width: 27px;
        height: 27px;
      `}
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
